import { c as _c } from "react/compiler-runtime";
import { ChipStatusDropdown } from '@/components/ChipStatusDropdown';
import { UpdateStatusModal } from '@/components/UpdateStatusModal';
import { useUpdateSurveyStatus } from '@/hooks/useUpdateSurveyStatus';
import type { Status } from '@/models/status';
import type { SurveyHome } from '@/models/survey';
type UpdateStatusRenderCellProps = {
  survey: SurveyHome;
  statuses: Status[];
};
export const UpdateStatusRenderCell = t0 => {
  const $ = _c(17);
  const {
    survey,
    statuses
  } = t0;
  const {
    updatedStatus,
    setUpdatedStatus,
    confirmationModalContent,
    updateSurveyStatus,
    isLoadingUpdateStatus
  } = useUpdateSurveyStatus(survey);
  let t1;
  if ($[0] !== setUpdatedStatus) {
    t1 = newStatus => {
      setUpdatedStatus(newStatus);
    };
    $[0] = setUpdatedStatus;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !survey.gates.authorizedToUpdate;
  let t3;
  if ($[2] !== statuses || $[3] !== survey.status || $[4] !== t1 || $[5] !== t2) {
    t3 = <ChipStatusDropdown onStatusChange={t1} isDisabled={t2} statuses={statuses} currentStatus={survey.status} />;
    $[2] = statuses;
    $[3] = survey.status;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== confirmationModalContent || $[8] !== isLoadingUpdateStatus || $[9] !== setUpdatedStatus || $[10] !== survey || $[11] !== updateSurveyStatus || $[12] !== updatedStatus) {
    t4 = <UpdateStatusModal updatedStatus={updatedStatus} currentSurvey={survey} updateSurveyStatus={updateSurveyStatus} confirmationModalContent={confirmationModalContent} setUpdatedStatus={setUpdatedStatus} isLoading={isLoadingUpdateStatus} />;
    $[7] = confirmationModalContent;
    $[8] = isLoadingUpdateStatus;
    $[9] = setUpdatedStatus;
    $[10] = survey;
    $[11] = updateSurveyStatus;
    $[12] = updatedStatus;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};